import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ConceptModel } from '../../concept/concept/concept.model';
import { InvoiceTaxModel } from './invoicetax.model';
import { ConceptService } from '../../concept/concept/concept.service';
import { Observable } from 'rxjs';
import { ExpenseModel } from './expense.model';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Utils } from '../../../shared/utils';
import { AccountModel } from '../../invoice/preinvoice/account.model';
import { ExpenseService } from './expense.service';
import { AccountsAndTaxesModel } from './accountsandtaxes.model';
import { ContactPropertyModel } from '../../contact/contact/contact-property.model';
import { UserFirstTimeActionService } from '../../user/user-first-time-action/user-first-time-action.service';
import { UserFirstTimeNewExpenseDialogComponent } from '../../user/user-first-time-action/user-first-time-new-expense/user-first-time-new-expense.component';
import { map } from 'rxjs';
import { Option } from '../../../shared/models/option.model';
import { ExpenseClassificationService, ClasificadorGastoPartida } from './expense-classification.service';

@Component({
    selector: 'convfact-expense-form-item',
    templateUrl: './expense-form-item.component.html',
    styleUrls: [],
    standalone: false
})

export class ExpenseFormItemComponent implements OnInit {
  @Input() contactProperties = new ContactPropertyModel();
  @Input() item = new ExpenseModel();
  @Input() taxes = Array<InvoiceTaxModel>();
  @Input() concepts = Array<ConceptModel>();
  chipsArray: [{}];

  conceptCtrl: UntypedFormControl;
  filteredConcepts: Observable<ConceptModel[]>;

  // Aqui recibimos el número de cuenta contable del gasto - sera null para señalar que es el mismo que el del gasto
  // Y tendra un valor distinto a null ( Cuenta contable ) para señalar que tiene un valor diferente
  @Input() expenseAccount: string = null;
  // Guardará el valor para determinar si el campo de cuenta contable se muestra en base a el valor del campo ${expenseAccount} || ${this.item.expenseAccount}
  showExpenseAccount: boolean = false;

  // Autocomplete Cuentas contables de gastos
  expenseCtrl: UntypedFormControl;
  filteredExpenses: Observable<AccountModel[]>;
  @Input() expenseList: AccountModel[] = [];

  // IGIC Importación
  isIgicImport: boolean = false;
  //taxesIgicImport = Array<InvoiceTaxModel>();
  accountsAndTaxes = new AccountsAndTaxesModel;

  private isFirstTime: boolean = true;

  public get contactPropertiesOptions(): Option[] {
    return ((this.contactProperties as any) || []).map((property: any) => ({ label: property.cadastralReference, value: property.uid }));
  }

  // Clasificador de gastos (partida/subpartida/familia) por concepto - solo asociaciones/fundaciones
  clasificadorCatalog: ClasificadorGastoPartida[] = [];
  clasificadorPartidas: any[] = [];
  clasificadorSubpartidas: any[] = [];
  clasificadorFamilias: any[] = [];

  constructor(
    private conceptService: ConceptService,
    public snackBar: MatSnackBar,
    private expenseService: ExpenseService,
    private dialog: MatDialog,
    private userFirstTimeActionService: UserFirstTimeActionService,
    private expenseClassificationService: ExpenseClassificationService
  ) {
    this.conceptCtrl = new UntypedFormControl();
    this.filteredConcepts = this.conceptCtrl.valueChanges
      .pipe(
        map(concept => concept ? this.filterConcepts(concept) : null)
        );
  }

  toZero() {
    // ESTO PARA QUE? ESTA REINICIANDO UN IMPORTE QUE ESTA BIEN
    // if (this.isFirstTime) {
    //   this.item.unityAmount = null;
    //   this.isFirstTime = false;
    // }
  }

  filterConcepts(name: string) {
    return this.concepts.filter(concept =>
      concept.name.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  ngOnInit() {
    // Al editar un gasto verificamos el valor de sus valores para marcar el campo check
    if (!Utils.IsNullOrEmpty(this.item.expenseAccount) && this.expenseAccount !== this.item.expenseAccount) {
      this.showExpenseAccount = true;
    }

    // Taxes - IGIC Importación
    // 30122022 -> Es un valor "mágico" de control, nos indica que viene unicamente desde el formulario de gastos y es para marcar ->
    // la linea de concepto como "IGIC Importación"
    if (this.item !== undefined && this.item.customsValue !== undefined && this.item.customsValue !== null) {
      this.isIgicImport = true;

      // Obtenemos el listadode igic
      this.expenseService.accountsEmptyAndTaxesIgicImportData().then(accountsAndTaxes => {
        this.accountsAndTaxes = accountsAndTaxes;
      });
      //this.taxesIgicImport = this.taxes.filter(tax => tax.type === 'IGIC IMPORTACIÓN');
      if (this.item.customsValue === 30122022) {
        this.item.customsValue = null;
      }
    }

    this.expenseCtrl = new UntypedFormControl();
    this.filteredExpenses = this.expenseCtrl.valueChanges
      .pipe(
        map(account => account && typeof account === 'object' ? account.number : account),
        map(name => this.filterExpenses(name))
      );

    this.conceptService.getList().then(
      concepts => {
        this.concepts = concepts;
      }
    )

    this.loadClasificadorGastos();

    this.userFirstTimeActionService.getAll().then(response => {
      if (response && response.filter(c => c.action == 'CREATE_EXPENSE').length == 0) {
        const dialogRef = this.dialog.open(UserFirstTimeNewExpenseDialogComponent, {
          panelClass: 'custom-dialog'
        });

        dialogRef.afterClosed().subscribe((result: boolean) => {
          if (result) {
            this.userFirstTimeActionService.add('CREATE_EXPENSE').then(res => {

            });
          }
        });
      }
    });
  }

  setTax = function (tax: InvoiceTaxModel, item: ExpenseModel) {
    tax.taxId = tax.id;

    // Verificar si ya se ha aplicado exactamente este impuesto
    const alreadyApplied = item.taxes.some(t => t.id === tax.id);
    if (alreadyApplied) {
      this.displayInfo('Este impuesto ya ha sido aplicado.');
      return;
    }

    const isRecargoEquiv = tax.name.toLowerCase().includes('recargo equiv');
    const impuestosPrincipalesDelMismoTipo = item.taxes.filter(t =>
      t.type === tax.type && !t.name.toLowerCase().includes('recargo equiv')
    );

    // Si ya hay un impuesto principal del mismo tipo, no permitir otro
    if (!isRecargoEquiv && impuestosPrincipalesDelMismoTipo.length > 0) {
      this.displayInfo(`Ya se ha aplicado un impuesto principal del tipo ${tax.type}.`);
      return;
    }

    // Permitir Inversión S.P. solo una vez
    const isInversionSP = tax.name.includes("Inversión S.P.");
    const hasInversionSP = item.taxes.some(t => t.name.includes("Inversión S.P."));
    if (isInversionSP && hasInversionSP) {
      this.displayInfo('Ya se ha aplicado un impuesto de Inversión S.P.');
      return;
    }

    item.taxes.push(tax);
  };

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 3000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  changeChips = function (element: ExpenseFormItemComponent) {
    element.item.taxes.forEach(tax => {
      element.setTax(tax, element.item);
    });
  }

  onShowExpenseAccountChange(event: MatCheckboxChange) {
    // Al crear un nuevo componente expense-form-item añadiremos el valor del campo de gasto al nuevo componente
    if (event.checked === true) {
      if (!Utils.IsNullOrEmpty(this.expenseAccount) && Utils.IsNullOrEmpty(this.item.expenseAccount)) {

        let valueExpenseAccount: string = this.expenseAccount;
        const indexOfExpenseAccount: number = this.expenseAccount.indexOf('-');
        if (indexOfExpenseAccount !== -1) {
          valueExpenseAccount = this.expenseAccount.substring(0, indexOfExpenseAccount);
        }
        this.item.expenseAccount = valueExpenseAccount.trim();

      }
    }

    // Si el usuario activa la opción y pone un valor en el campo "Cuenta contable" pero luego lo quita, reseteamos el valor a null
    if (event.checked === false) {
      this.item.expenseAccount = null;
    }
  }

  filterExpenses(val: string) {
    for (const account of this.expenseList) {
      if (account.number == val || account.name == val) {
        this.item.expenseAccount = account.number;
      }
    }
    if (val) {
      // Busqueda por el número de cuenta contable
      return this.expenseList.filter(s => s.number.toLowerCase().indexOf(val.toLowerCase()) === 0);
    }

    return this.expenseList;
  }

  isRent() {
    return this.item.taxes.filter(s => s.name.toLowerCase().indexOf('arren') !== -1).length > 0;
  }

  onSelectTax(data: any) {
    this.setTax(this.taxes.filter(c => c.id == data)[0], this.item)
  }

  public trackByIndex(i: number) { return i; }

  private loadClasificadorGastos(): void {
    this.expenseClassificationService.getCatalog().then(catalog => {
      this.clasificadorCatalog = catalog || [];
      this.clasificadorPartidas = this.clasificadorCatalog.map(p => ({ id: p.nombre, data: p.nombre }));

      // Si la línea ya viene con clasificación (edición de un gasto existente), reconstruir las listas en cascada
      if (this.item.clasificadorPartida) {
        this.recomputeSubpartidas(this.item.clasificadorPartida);
      }
      if (this.item.clasificadorPartida && this.item.clasificadorSubpartida) {
        this.recomputeFamilias(this.item.clasificadorPartida, this.item.clasificadorSubpartida);
      }
    });
  }

  private recomputeSubpartidas(partidaNombre: string): void {
    const partida = this.clasificadorCatalog.find(p => p.nombre === partidaNombre);
    this.clasificadorSubpartidas = partida ? partida.subpartidas.map(s => ({ id: s.nombre, data: s.nombre })) : [];
  }

  private recomputeFamilias(partidaNombre: string, subpartidaNombre: string): void {
    const partida = this.clasificadorCatalog.find(p => p.nombre === partidaNombre);
    const subpartida = partida ? partida.subpartidas.find(s => s.nombre === subpartidaNombre) : null;
    this.clasificadorFamilias = subpartida ? subpartida.familias.map(f => ({ id: f, data: f })) : [];
  }

  // Se usan para forzar que Angular destruya y recree los desplegables de Subpartida/Familia
  // al cambiar de Partida/Subpartida (*ngIf con este flag), en vez de reutilizar la misma
  // instancia de app-autocomplete-select y depender de que ella limpie su texto interno
  // (ese componente es compartido por medio formulario y no se debe tocar su comportamiento).
  showSubpartidaSelect = true;
  showFamiliaSelect = true;

  onClasificadorPartidaChange(partidaNombre: string): void {
    this.item.clasificadorPartida = partidaNombre;
    this.item.clasificadorSubpartida = null;
    this.item.clasificadorFamilia = null;

    this.recomputeSubpartidas(partidaNombre);
    this.clasificadorFamilias = [];

    this.showSubpartidaSelect = false;
    this.showFamiliaSelect = false;
    setTimeout(() => {
      this.showSubpartidaSelect = true;
      this.showFamiliaSelect = true;
    });
  }

  onClasificadorSubpartidaChange(subpartidaNombre: string): void {
    this.item.clasificadorSubpartida = subpartidaNombre;
    this.item.clasificadorFamilia = null;

    this.recomputeFamilias(this.item.clasificadorPartida, subpartidaNombre);

    this.showFamiliaSelect = false;
    setTimeout(() => this.showFamiliaSelect = true);
  }

}
